import { render, staticRenderFns } from "./hires.vue?vue&type=template&id=f9ffb9dc&scoped=true&"
import script from "./hires.vue?vue&type=script&lang=js&"
export * from "./hires.vue?vue&type=script&lang=js&"
import style0 from "./hires.vue?vue&type=style&index=0&id=f9ffb9dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ffb9dc",
  null
  
)

export default component.exports